import React from 'react'
import translate from '../../../reusable/translate'
import DatePicker from 'react-datepicker'


const DatePickingContainer = ({ commitment, startingDate, endingDate,
    setters, minReportingDate, maxReportingDate, disabled }) => {

    return(
        <div>

            <p className="p">
                <b>
                    {translate({textKey: "sit.profile.operationReport.selectReportTime"})}:
                </b>
            </p>

            <div className="flex-row items-center">

                <DatePicker
                    className={"input-padding"}
                    selected={startingDate}
                    dropdownMode={"select"}
                    onChange={(date) => setters.setStartingDate(date)}
                    placeholderText={translate({textKey: "sit.commitment.operations.chooseStartingDate"})}
                    minDate={minReportingDate}
                    maxDate={endingDate || maxReportingDate}
                    disabled={disabled}
                />
                <DatePicker
                    className={"input-padding"}
                    selected={endingDate}
                    dropdownMode={"select"}
                    onChange={(date) => setters.setEndingDate(date)}
                    placeholderText={translate({textKey: "sit.commitment.operations.chooseEndingDate"})}
                    minDate={startingDate || minReportingDate}
                    maxDate={maxReportingDate}
                    disabled={disabled}
                />

            </div>

        </div>
    )
}

export default DatePickingContainer


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/DatePickingContainer.jsx